import React from "react";
import SolidarioCheckbox from "./SolidarioCheckbox";

const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString("es-EC", { day: "2-digit", month: "2-digit", year: "numeric" });
};

// Fila de la tabla de CarteraBancoSolidario.js — markup y clases tomadas
// directamente del mockup de Stitch (tr resaltada + shadow-md cuando está
// seleccionada, checkbox en el color de marca de Banco Solidario #01BEDE).
export default function CarteraTableRow({ data, index, checked, onToggle, onQuitarLote, onQuitarExcel, quitando }) {
  const tieneLote = Number(data.lote) > 0;
  const confirmado = data.confirmado === true;
  const yaEnLote = data.yaEnLote === true;
  // Filas traídas por "Cargar selección Excel" (créditos sin firma electrónica o cuota avanzada,
  // el banco los compra directo): todavía no tienen lote asignado, así que se quitan de la
  // selección local en vez de llamar a desgenerar-lote (no hay nada persistido aún que revertir).
  const esExcelSinLote = data.sinFirmaElectronica === true && !tieneLote && !yaEnLote;

  return (
    <tr
      onClick={() => !yaEnLote && onToggle(data.idCre_SolicitudWeb)}
      className={`transition-colors ${
        yaEnLote
          ? "opacity-50 bg-gray-50 cursor-not-allowed"
          : `cursor-pointer ${checked ? "bg-[#01BEDE]/20 shadow-md" : "hover:bg-gray-50"}`
      }`}
    >
      <td className="px-4 py-4 whitespace-nowrap" onClick={(e) => e.stopPropagation()}>
        <SolidarioCheckbox checked={checked} disabled={yaEnLote} onChange={() => onToggle(data.idCre_SolicitudWeb)} />
      </td>
      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-700 font-medium">{data.lote ?? 0}</td>
      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-600">{data.NumeroSolicitud}</td>
      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-600">{formatDateTime(data.Fecha)}</td>
      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-600">{data.Cedula}</td>
      <td className={`px-4 py-4 whitespace-nowrap text-sm text-gray-700 ${checked ? "font-bold" : "font-medium"}`}>
        {data.cliente || "-"}
        {yaEnLote ? (
          <span className="ml-2 text-[10px] font-semibold text-gray-600 border border-gray-300 bg-gray-100 rounded-md px-1.5 py-0.5 align-middle">
            Ya en lote {data.lote} — no se generará
          </span>
        ) : data.sinFirmaElectronica && (
          <span className="ml-2 text-[10px] font-semibold text-orange-700 border border-orange-300 bg-orange-50 rounded-md px-1.5 py-0.5 align-middle">
            Sin firma electrónica
          </span>
        )}
      </td>
      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-600 font-mono">{data.numeroOperacion || "-"}</td>
      <td className="px-4 py-4 whitespace-nowrap" onClick={(e) => e.stopPropagation()}>
        {esExcelSinLote && (
          <button
            type="button"
            onClick={() => onQuitarExcel(data.idCre_SolicitudWeb)}
            className="text-xs font-semibold text-red-500 border border-red-300 rounded-md px-2 py-1 hover:bg-red-50 transition-colors"
          >
            Quitar
          </button>
        )}
        {!esExcelSinLote && !yaEnLote && tieneLote && !confirmado && (
          <button
            type="button"
            onClick={() => onQuitarLote(data.idCre_SolicitudWeb)}
            disabled={quitando}
            className="text-xs font-semibold text-red-500 border border-red-300 rounded-md px-2 py-1 hover:bg-red-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {quitando ? "Quitando..." : "Quitar"}
          </button>
        )}
        {!yaEnLote && confirmado && (
          <span className="text-xs font-semibold text-emerald-700 border border-emerald-300 bg-emerald-50 rounded-md px-2 py-1">
            Confirmado
          </span>
        )}
      </td>
    </tr>
  );
}
